import { render, staticRenderFns } from "./order_pay.vue?vue&type=template&id=67f7ef91&scoped=true&"
import script from "./order_pay.vue?vue&type=script&lang=js&"
export * from "./order_pay.vue?vue&type=script&lang=js&"
import style0 from "./order_pay.vue?vue&type=style&index=0&id=67f7ef91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7ef91",
  null
  
)

component.options.__file = "order_pay.vue"
export default component.exports